import { clsx, type ClassValue } from "clsx";
import React from "react";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function renderFormattedText(text: string): React.ReactNode {
  if (!text) return text;

  const regex = /\[([^\]]+)\]\(([^)]+)\)|\*\*([^*]+)\*\*|\*([^*]+)\*/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  const elements: React.ReactNode[] = [];
  let key = 0;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      elements.push(text.substring(lastIndex, match.index));
    }
    if (match[1] && match[2]) {
      const isInternal = match[2].startsWith("/") && !match[2].startsWith("//");
      const isMailOrTel = match[2].startsWith("mailto:") || match[2].startsWith("tel:");
      elements.push(
        <a
          key={`link-${key++}`}
          href={match[2]}
          {...(!isInternal && !isMailOrTel ? { target: "_blank", rel: "noopener noreferrer" } : {})}
          className="text-brand-yellow hover:underline transition-colors break-words font-medium"
        >
          {match[1]}
        </a>
      );
    } else if (match[3]) {
      elements.push(
        <strong key={`bold-${key++}`} className="text-white font-semibold">
          {match[3]}
        </strong>
      );
    } else if (match[4]) {
      elements.push(
        <em key={`italic-${key++}`} className="italic">
          {match[4]}
        </em>
      );
    }
    lastIndex = regex.lastIndex;
  }

  // If there was no markdown pattern at all, return the original string
  if (elements.length === 0) {
    return text;
  }

  // Append any trailing text after the last match
  if (lastIndex < text.length) {
    elements.push(text.substring(lastIndex));
  }

  return <>{elements}</>;
}